module.exports = __webpack_public_path__ + "assets/images/slope-single/mobile.svg?v=39d10efe";